// authSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { handleLocationMasterList, handleLocationMasterRemove } from "../../../Api/api";

// Define an initial state for the slice
const initialState = {
   data: null,
   loading: false,
   error: null,
};

// Create an async thunk for the login action
export const locationMasterListAsync = createAsyncThunk(
   "locationMaster/add",
   async ({ done, err }, thunkAPi) => {
      try {
         // ;
         const { data: response } = await handleLocationMasterList();
         if (response.statusCode === 200) {
            done && done();
            return thunkAPi.fulfillWithValue(response.res);
         } else {
            throw response;
         }
      } catch (error) {
         // You can customize the error handling here
         
         err && err(error.message);
         return thunkAPi.rejectWithValue(error);
      }
   }
);

// remove location record from master table
export const removeLocationMasterAsync = createAsyncThunk(
   "kiloleterMaster/remove",
   async ({ id, done, err }) => {
      try {
         const response = await handleLocationMasterRemove(id);
         done && done();
         return response.data;
      } catch (error) {
         const errorMessage =
            error?.response?.data?.message || "Failed to delete Location";

         err && err(errorMessage);
         throw error?.response?.data || errorMessage;
      }
   }
);




// Create a slice of the Redux store
const locationMasterListSlice = createSlice({
   name: "locationMaster",
   initialState,
   reducers: {
      // You can define additional synchronous actions here if needed
   },
   extraReducers: (builder) => {
      builder
         .addCase(locationMasterListAsync.pending, (state) => {
            state.loading = true;
            state.error = null;
         })
         .addCase(locationMasterListAsync.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            // 
         })
         .addCase(locationMasterListAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload; // error message from the rejectWithValue call
         });
   },
});

// Export the reducer
export default locationMasterListSlice.reducer;
